import React from 'react';

import { Avatar, AvatarProps, parseClassnames } from '@crehana/ui';

import { LiveNode_presenters as Presenters } from '../graphql/types/LiveNode';
import { Presenter } from '../graphql/types/Presenter';

interface SpeakersProps extends Pick<AvatarProps, 'size'> {
  presenter?: Presenter | null;
  presenters: Presenters | null;
  className?: string;
}

const Speakers: React.FC<SpeakersProps> = ({
  size = 24,
  presenter,
  presenters,
  className = '',
}) => {
  const speakers = React.useMemo(() => {
    if (presenters?.edges.length) {
      return presenters.edges.map(e => e!.node!);
    }
    if (presenter) {
      return [presenter];
    }
    return [];
  }, [presenter, presenters]);
  const speakersNames = speakers.map(({ fullName }) => fullName).join(' + ');
  const isMultiSpeaker = speakers.length > 1;

  if (!speakers.length) {
    return null;
  }

  // Typecas so typescript doesn't complaint
  const sizeNumber = size as number;

  return (
    <div
      className={parseClassnames(
        className,
        'flex flex-wrap items-center mr-16 text-white',
      )}
    >
      <div
        className="relative"
        style={{
          width: sizeNumber + speakers.length * (sizeNumber / 2),
          height: sizeNumber,
        }}
      >
        {speakers.map((speaker, i) => (
          <Avatar
            key={speaker.originalId!}
            src={speaker.thumbnailUrl}
            size={size}
            className="absolute"
            style={{ left: (sizeNumber / 2) * i }}
          />
        ))}
      </div>
      {isMultiSpeaker ? (
        <>
          <span className="font-body4 text-inherit md:hidden">
            {speakersNames}
          </span>
          <span className="font-body3 text-inherit hidden md:block">
            {speakersNames}
          </span>
        </>
      ) : (
        <>
          <span className="font-body2 text-inherit md:hidden">
            {speakersNames}
          </span>
          <span className="font-body3 text-inherit hidden md:block">
            {speakersNames}
          </span>
        </>
      )}
    </div>
  );
};

export default Speakers;
